import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { BackButton } from "../../components/common/MainButtonComponent";
import { routes } from "../../helper/routes";
import AssessmentSetupForm from "./AssessmentSetupForm";
import "./AssessShared.css";

export default function AssessmentForm({metaData, metaDataOptions,goBack, goBackWithRefresh}) {
  const history = useHistory();
  const location = useLocation();
  const resolvedMetaData = location.state?.metaData || metaData || null;
  const resolvedMetaDataOptions =location.state?.metaDataOptions || metaDataOptions || null;

  return (
    <ContentWrapper>
      <section className="assess-section">
        <div className="assess-section__header">
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <BackButton
              title="Back"
              // onClick={() => history.push(routes.asses_lib)}
              onClick={goBack}
            />
            <div>
              <p className="assess-section__eyebrow">Assessment Library</p>
              <h1 className="assess-section__title">Add Assessment</h1>
            </div>
          </div>
        </div>

        <AssessmentSetupForm
          submitLabel="Create"
          metaData={resolvedMetaData}
          metadataOptionsOverride={resolvedMetaDataOptions}
          // onClose={() => history.push(routes.asses_lib)}
          onClose={goBackWithRefresh}
        />
      </section>
    </ContentWrapper>
  );
}
